"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.sync.model.button': 'Sincronizza Modello',
    'chat.sync.model.tooltip': 'Sincronizza con il modello di conversazione',
};
